import { useMemo } from 'react';
import { FinanceFormType, useFinanceCalculatorContext } from '../../context';

export interface FieldsHook {
  type: FinanceFormType;
}

export default function useFields(): FieldsHook {
  const { stored } = useFinanceCalculatorContext();

  const type = useMemo(() => stored.type, [stored]);

  return {
    type,
  };
}
